import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const GithubActionsPlugin = createPlugin({
  id: 'tomtom-github-actions',
  routes: {
    root: rootRouteRef,
  },
});

export const GithubActionVersionsCard = GithubActionsPlugin.provide(
  createRoutableExtension({
    name: 'GithubActionVersionsCard',
    component: () =>
      import('./components/VersionsCard').then(m => m.VersionsCard),
    mountPoint: rootRouteRef,
  }),
);
